import React, { useState, useEffect, useRef } from 'react';
import { Select, Button, Typography, message, Space } from 'antd';
import { apiClient } from '../../api_actions/index';
import { useRoleNameStore, useIsAdmin, useIsSuperAdmin, useDeploymentListStore } from '../../store';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
const { Text, Title, Link } = Typography;

import './style.scss';

const ExclusionZonePage = ({
  deployment_key,
  modesEndpoint,
  exclusionZonesEndpoint,
  imageEndpoint,
  saveZoneEndpoint,
  deleteZoneEndpoint,
  streamsEndpoint,
  location_name
}) => {
  const [modes, setModes] = useState([]);
  const [streams, setStreams] = useState([]);
  const [selectedMode, setSelectedMode] = useState(null);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [zones, setZones] = useState([]);
  const [currentPolygon, setCurrentPolygon] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const roleName = useRoleNameStore((state) => state.roleName);
  const isAdmin = useIsAdmin();
  const isSuperAdmin = useIsSuperAdmin();

  // const navigate = useNavigate();
  const location = useLocation();
  // const deployments = useDeploymentListStore((state) => state.deployments);
  // const currentIndex = deployments.findIndex(
  //     d => String(d.deployment_id) === String(deployment_key)
  // );

  // const handleNavigate = (newIndex) => {
  //     const target = deployments[newIndex];
  //     navigate(`/zones/${target.deployment_id}/${target.location_name}`, {
  //         state: { deployments } // carry the list forward
  //     });
  // };

  // const hasPrev = currentIndex > 0;
  // const hasNext = currentIndex < deployments.length - 1;
  
  const canvasRef = useRef(null);
  const imageRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    loadModes();
    loadStreams();
  }, []);

  useEffect(() => {
    loadImage();
    loadZones();
  }, [selectedCamera, selectedMode]);

  useEffect(() => {
    if (imageLoaded) {
      drawCanvas();
    }
  }, [zones, currentPolygon, selectedZone, imageLoaded]);

  const loadModes = async () => {
    try {
      const result = await apiClient.post(modesEndpoint);
      setModes(result.data || []);
      if (result.data && result.datalength > 0) {
        setSelectedMode(result.data[0].detection_package_id);
      }
    } catch (error) {
      console.error('Failed to load modes', error);
      message.error('Failed to load modes');
    }
  };

  const loadStreams = async () => {
    try {
        const result = await apiClient.post(streamsEndpoint);
        setStreams(result.data || []);
        if (result.data && result.data.length > 0) {
            setSelectedCamera(result.data[0].id);
        }
    } catch (error) {
        console.error('Failed to load streams', error);
        message.error('Failed to load streams');
    }
    };

  const loadImage = async () => {
    if (!selectedCamera) return;

    try {
      setImageLoaded(false);
      if (selectedCamera !== null){
        const result = await apiClient.post(imageEndpoint, { id: selectedCamera });
        //const base64_img = result.data;
        imageRef.current.src = `data:image/png;base64,${result.data.replace(/['"]+/g, '')}`;
        imageRef.current.onload = () => {
          setImageLoaded(true);
        };
      }
    } catch (error) {
      console.error('Failed to load image', error);
      message.error('Failed to load image');
    }
  };

  const loadZones = async () => {
    try {
      const result = await apiClient.post(exclusionZonesEndpoint, { stream_id: selectedCamera, detection_package_id: selectedMode });
      setZones(result.data || []);
    } catch (error) {
      console.error('Failed to load zones', error);
      message.error('Failed to load zones');
    }
  };

// Update drawCanvas
const drawCanvas = () => {
  const canvas = canvasRef.current;
  const ctx = canvas.getContext('2d');
  const img = imageRef.current;

  if (!img.complete) return;

  // Use displayed dimensions
  canvas.width = img.clientWidth;
  canvas.height = img.clientHeight;

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  zones.forEach(zone => {
    const points = JSON.parse(zone.exclusion_points);
    const detection_package_id = JSON.parse(zone.detection_package_id)

    const mode = modes.filter((mode) => mode.detection_package_id == detection_package_id)[0]

    drawPolygon(ctx, points, zone === selectedZone, canvas.width, canvas.height, mode.color);
  });

  if (currentPolygon.length > 0) {
    const mode = modes.filter((mode) => mode.detection_package_id == selectedMode)[0]
    drawPolygon(ctx, currentPolygon, false, canvas.width, canvas.height, mode.color, true);
  }
};

  const adjustAlpha = (rgbaString, adjustment) => {
    return rgbaString.replace(/[\d.]+\)$/g, (match) => {
      const currentAlpha = parseFloat(match);
      const newAlpha = Math.max(0, Math.min(1, currentAlpha + adjustment));
      return `${newAlpha})`;
    });
  };

  const drawPolygon = (ctx, points, isSelected, width, height, color, isDrawing = false) => {
    if (points.length < 2) return;

    ctx.beginPath();
    points.forEach((point, index) => {
      const x = point[0] * width;
      const y = point[1] * height;
      if (index === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    });

    if (!isDrawing) {
      ctx.closePath();
    }

    const originalColor = color;
    const lowerAlpha = adjustAlpha(originalColor, -0.1); // 'rgba(100, 100, 100, 0.3)'
    const higherAlpha = adjustAlpha(originalColor, 0.1)
    const maxAlpha = adjustAlpha(originalColor, 1.0)

    ctx.fillStyle = isSelected 
      ? originalColor 
      : lowerAlpha;

    if (!isDrawing) {
      ctx.fill(); // ADD THIS LINE - actually fill the polygon
    }

    // Stroke
    ctx.strokeStyle = isSelected ? higherAlpha : originalColor;
    ctx.lineWidth = isSelected ? 3 : 2;
    ctx.stroke();

    // Draw vertices
    points.forEach(point => {
      const x = point[0] * width;
      const y = point[1] * height;
      ctx.beginPath();
      ctx.arc(x, y, 4, 0, 2 * Math.PI);
      ctx.fillStyle = isSelected ? maxAlpha : higherAlpha;
      ctx.fill();
    });
  };

  const handleCanvasClick = (e) => {

    if (!selectedMode) {
      message.warning('Please select a mode first');
      return;
    }

    if (!isSuperAdmin) {
      message.error('Only super administrators can modify zones');
      return;
    }

    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    // Check if clicking on existing zone
    const clickedZone = zones.find(zone => {
      const points = JSON.parse(zone.exclusion_points);
      return isPointInPolygon([x, y], points);
    });

    if (clickedZone) {
      setSelectedZone(clickedZone);
      return;
    }

    // Add point to current polygon
    setCurrentPolygon([...currentPolygon, [x, y]]);
    setSelectedZone(null);
  };

  const isPointInPolygon = (point, polygon) => {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0], yi = polygon[i][1];
      const xj = polygon[j][0], yj = polygon[j][1];
      
      const intersect = ((yi > point[1]) !== (yj > point[1]))
          && (point[0] < (xj - xi) * (point[1] - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  };

  const handleSavePolygon = async () => {
    if (currentPolygon.length < 3) {
      message.warning('A polygon needs at least 3 points');
      return;
    }

    const zoneData = {
      detection_package_id: selectedMode,
      exclusion_points: JSON.stringify(currentPolygon),
      stream_id: selectedCamera,
    };

    try {
      await apiClient.post(saveZoneEndpoint, zoneData);
      message.success('Zone saved successfully');
      setCurrentPolygon([]);
      await loadZones();
    } catch (error) {
      console.error('Failed to save zone', error);
      message.error('Failed to save zone');
    }
  };

  const handleDeleteZone = async () => {
    if (!selectedZone) {
      message.warning('Please select a zone to delete');
      return;
    }

    try {
      await apiClient.post(deleteZoneEndpoint, selectedZone);
      message.success('Zone deleted successfully');
      setSelectedZone(null);
      await loadZones();
    } catch (error) {
      console.error('Failed to delete zone', error);
      message.error('Failed to delete zone');
    }
  };

  const handleCancelDrawing = () => {
    setCurrentPolygon([]);
  };

  return (
    <div style={{ padding: '2px', fontFamily: 'sans-serif' }}>
      <div style={{display: 'flex',alignItems: 'center',justifyContent: 'space-between',marginBottom: 16,}}>
          {/* <Button
              onClick={() => handleNavigate(currentIndex - 1)}
              disabled={!hasPrev}
          >
              &larr; Previous
          </Button> */}

          <div style={{
              flex: 1,
              textAlign: 'left',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              padding: '0 16px',
          }}>
              <h2 style={{ margin: 0 }}>{location_name}</h2>
          </div>

          {/* <Button
              onClick={() => handleNavigate(currentIndex + 1)}
              disabled={!hasNext}
          >
              Next &rarr;
          </Button> */}
      </div>
    <div className="exclusion-zone-container">

      <div className="exclusion-zone-controls">
        <div className="exclusion-zone-control-group">
          <label>Camera:</label>
          <Select
            className="exclusion-zone-camera-select"
            value={selectedCamera}
            onChange={(value) => {
                setSelectedCamera(value);
                setCurrentPolygon([]);
                setSelectedZone(null);
            }}
          >
            {streams.map(stream => (
                <Select.Option key={stream.id} value={stream.id}>
                    <div className="stream-select-option">
                        <div className="stream-name">{stream.name}</div>
                        <div className="stream-endpoint">
                            {stream.endpoint}
                        </div>
                    </div>
                </Select.Option>
            ))}
          </Select>
        </div>

        <div className="exclusion-zone-control-group">
          <label>Mode:</label>
          <Select
            className="exclusion-zone-mode-select"
            value={selectedMode}
            onChange={setSelectedMode}
            placeholder="Select mode"
          >
            {modes.map(mode => (
              <Select.Option key={mode.detection_package_id} value={mode.detection_package_id}>
                {mode.detection_package_name}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="exclusion-zone-button-group">
          {currentPolygon.length > 0 && (
            <>
              <Button onClick={handleCancelDrawing}>Cancel</Button>
              <Button type="primary" onClick={handleSavePolygon}>
                Save Polygon ({currentPolygon.length} points)
              </Button>
            </>
          )}
          {selectedZone && (
            <Button danger onClick={handleDeleteZone}>
              Delete Selected Zone
            </Button>
          )}
        </div>
      </div>

      <div className="exclusion-zone-canvas-container" ref={containerRef}>
        {!imageLoaded && (
           <div className="loading-overlay">Loading Image...</div>
        )}
        
        <img
          ref={imageRef}
          className="exclusion-zone-image"
          alt="Camera view"
        />
        <canvas
          ref={canvasRef}
          className="exclusion-zone-canvas"
          onClick={isSuperAdmin ? handleCanvasClick : undefined}
          style={{ cursor: isSuperAdmin ? 'crosshair' : 'not-allowed' }}
        />
      </div>

      <div className="exclusion-zone-instructions">
        <p><strong>Instructions:</strong></p>
        <ul>
          <li>Select a mode from the dropdown</li>
          <li>Click on the image to add points to your polygon</li>
          <li>Click "Save Polygon" when you're done drawing</li>
          <li>Click on existing zones to select them, then click "Delete" to remove</li>
        </ul>
      </div>
    </div>
    </div>
  );
};

export default ExclusionZonePage;